import { render, staticRenderFns } from "./CancellationBlock.vue?vue&type=template&id=8330d804&scoped=true&"
import script from "./CancellationBlock.vue?vue&type=script&lang=js&"
export * from "./CancellationBlock.vue?vue&type=script&lang=js&"
import style0 from "./CancellationBlock.vue?vue&type=style&index=0&id=8330d804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8330d804",
  null
  
)

export default component.exports